import React, {useEffect, useState} from "react";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import {DeleteButton} from "../../components/CFAdminDataTable/ActionsButtonComponents";
import VehicleConfigService from "../../services/VehicleConfigService";
import {VehicleAttributeType} from "./types";
import DeleteIcon from "../../assets/images/delete.svg";
import AddIcon from "../../assets/images/add-icon.svg";
import CFAdminConfirmDialog from "../../components/CFAdminConfirmDialog";

const ActionsCellComponent = (props: any) => {
    const { column } = props;
    return (
        <div className="cell-buttons">
            <DeleteButton {...props} handleDelete={column.handleDelete} />
        </div>
    );
};

const AttributeHeader = ({ attributeDescription, attributeId, onDelete }: { attributeDescription: string; attributeId: any; onDelete: (id: any) => void }) => (
    <div className="flex">
        <div className="inline-flex">{attributeDescription}
            &nbsp;
            <button
                data-testid={attributeId}
                onClick={() => onDelete(attributeId)}
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                aria-label={`Delete attribute ${attributeDescription}`}
            >
                <img src={DeleteIcon} alt="Xcelvations Logo" height="15"/>
            </button>
        </div>
    </div>
);

const AttributeHeaderCell = ({ column }: any) => (
    <AttributeHeader
        attributeDescription={column.attributeDescription}
        attributeId={column.attributeId}
        onDelete={column.onDelete}
    />
);

function CFAdminVehicleConfigDetails ({vehicleDetails, switchToCreate, closeModal, successMessage, errorMessage} : any) {

    const [columnValues, setColumnValues] = useState<any>([]);
    const [dataValues, setDataValues] = useState<any>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [modelYearId, setModelYearId] = useState<number>(0);
    const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
    const [isDeleteVehicleConfirmOpen, setIsDeleteVehicleConfirmOpen] = useState(false);
    const [isDeleteAttributeConfirmOpen, setIsDeleteAttributeConfirmOpen] = useState(false);
    const [deleteVehicleId, setDeleteVehicleId] = useState<number>(0);
    const [attributeId, setAttributeId] = useState<number>(0);

    const handleEdit = (event: any) => {
        switchToCreate();
    }

    const handleAttributeDelete = (attributeId: any) => {
        setAttributeId(attributeId);
        setIsDeleteAttributeConfirmOpen(true);
    }

    const handleDelete = async (event: any) => {
        setDeleteVehicleId(event.originalRow.vehicleId);
        setIsDeleteVehicleConfirmOpen(true);
    }

    const vehicleDeleteEvent = async () => {
        setIsDeleteConfirmOpen(true);
    }

    const invokeVehicleDelete = () => {
        if (modelYearId !==0)
        {
            VehicleConfigService.deleteModelYear(modelYearId)
                .then(() => {
                    successMessage(`Model: ${vehicleDetails.model} and Year: ${vehicleDetails.year} deleted successfully.`);
                    setIsDeleteConfirmOpen(false);
                    closeModal();
                })
                .catch(e => {
                    errorMessage("Error while deleting Model!");
                });
        } else {
            errorMessage("Invalid Model");
        }
    }

    const invokeVehicleConfigDelete = () => {
        if (modelYearId !== 0 && deleteVehicleId !== 0)
        {
            VehicleConfigService.deleteVehicle(deleteVehicleId)
                .then(() => {
                    successMessage(`Vehicle deleted successfully for Model: ${vehicleDetails.model} and Year: ${vehicleDetails.year}.`);
                    setIsDeleteVehicleConfirmOpen(false);
                    getVehicleConfigurations();
                })
                .catch(e => {
                    errorMessage("Error while deleting Model!");
                });
        } else {
            errorMessage("Invalid Model");
        }
    }

    const invokeVehicleAttributeDelete = () => {
        if (modelYearId !==0 && attributeId !==0)
        {
            VehicleConfigService.deleteVehicleAttribute(attributeId, modelYearId)
                .then(() => {
                    successMessage(`Model: ${vehicleDetails.model} and Year: ${vehicleDetails.year} deleted successfully.`);
                    setIsDeleteAttributeConfirmOpen(false);
                    getVehicleConfigurations();
                })
                .catch(e => {
                    errorMessage("Error while deleting Model!");
                    console.log(e);
                });

        } else {
            errorMessage("Invalid Model");
        }
    }

    const vehicleData = [
        {
            Year: vehicleDetails?.year,
            Make: vehicleDetails?.make,
            Model: vehicleDetails?.model === '' ? vehicleDetails?.modelDesc : vehicleDetails?.model
        },
    ];

    function getVehicleConfigurations(){
        const modelDesc = vehicleDetails?.model === '' ? vehicleDetails?.modelDesc : vehicleDetails?.model;

        VehicleConfigService.getVehicleConfigurationDetails(vehicleDetails?.make, modelDesc, vehicleDetails?.year)
            .then(response => {

                const responseModel = response.data?.vehicles;
                if (responseModel) {

                    let columns : any = [];
                    let data : any = [];
                    let count: number = 0;
                    let isColAdded : boolean = false;
                    responseModel.forEach((parentElement: any) => {
                        count = count+1;
                        if(!isColAdded) {
                            columns.push({Header: '', accessor:'id', disableSortBy: true});
                            processResponseModel(columns, parentElement);
                            pushColumns(columns);
                            isColAdded = true;
                        }
                        data.push(createJson(count, parentElement.vehicleId, parentElement.vehicleAttributes));
                        setModelYearId(parentElement.yearModelId);
                    });
                    setColumnValues(columns);
                    setDataValues(data);
                    setTotalRecords(count);
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    const processResponseModel = (columns: any, parentElement: any) => {
        parentElement.vehicleAttributes.forEach((childElement: VehicleAttributeType) => {
            pushParentColumns(childElement, columns);
        });
    }

    const pushParentColumns = (childElement: VehicleAttributeType, columns: any) => {
        columns.push({
            Header: AttributeHeaderCell,
            attributeDescription: childElement.attributeDescription,
            attributeId: childElement.attributeId,
            onDelete: handleAttributeDelete,
            disableSortBy: true,
            accessor: 'attributeValueDescription' + childElement.attributeId
        })
    }

    const pushColumns = (columns: any) => {
        columns.push({
            Header: "Actions", disableSortBy: true, accessor: '',
            Cell: ActionsCellComponent,
            handleDelete: handleDelete
        });
    }


    function createJson(count:number, vehicleId: number, childElements: any)
    {
        let jsonData : any = {};
        childElements.forEach((childElement: VehicleAttributeType) => {
            let columnName = 'attributeValueDescription'+childElement.attributeId;
            jsonData[columnName] = childElement.attributeValueDescription;
        });
        jsonData['id'] = 'Configuration ' + count;
        jsonData['vehicleId'] = vehicleId;

        return jsonData;
    }

    const renderTable = (data: any) => {
        const headings = ["Year", "Make", "Model"];
        return (
            <table className="inner-table">
                <thead>
                <tr>
                    {headings.map((heading) => (
                        <th style={{background: 'aliceblue', color:'black'}} key={heading}>
                            {heading} </th>
                    ))}
                    <th style={{background: 'aliceblue', color:'black'}}>
                        <button
                            data-testid="modal-delete"
                            onClick={vehicleDeleteEvent}
                            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'black' }}
                        >
                            Delete Vehicle &nbsp; <img src={DeleteIcon} alt="Xcelvations Logo" height="15"/>
                        </button></th>
                </tr>
                </thead>
                <tbody>
                {data.map((row : any, rowIndex:any) => (
                    <tr key={row.Year + '-' + row.Make + '-' + row.Model}>
                        { headings.map((heading) => (
                            <td key={row[heading]}>{row[heading]}</td>
                        ))}
                        <td onClick={handleEdit}>Generate New Configurations &nbsp;{' '}
                            <img src={AddIcon} alt="Xcelvations Logo" height="15"/> </td>
                    </tr>
                ))}
                </tbody>
            </table>
        );
    };

    useEffect(() => {
        getVehicleConfigurations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="ext5">
                Search Results
            </div>
            <div className="ext2">
                * {totalRecords} vehicle configurations were found for the vehicle listed below
            </div>
            <div>
                {renderTable(vehicleData)}
            </div>
                <CFAdminDataTable
                    columns={columnValues}
                    data={dataValues}
                    textModal={''}
                    showFilter={false}
                    showAdd={false}
                    showPagination={false}
                    pageSize={1000}
                />
            <CFAdminConfirmDialog
                isOpen={isDeleteConfirmOpen}
                onClose={()=>setIsDeleteConfirmOpen(false)}
                onConfirm={invokeVehicleDelete}
                title={`Delete Model: ${vehicleDetails.model} and Year: ${vehicleDetails.year}`}
                text="Are you sure you want to delete this Model?"
            />
            <CFAdminConfirmDialog
                isOpen={isDeleteVehicleConfirmOpen}
                onClose={()=>setIsDeleteVehicleConfirmOpen(false)}
                onConfirm={invokeVehicleConfigDelete}
                title={`Delete Configuration: ${vehicleDetails.model} and Year: ${vehicleDetails.year}`}
                text="Are you sure you want to delete this Model?"
            />
            <CFAdminConfirmDialog
                isOpen={isDeleteAttributeConfirmOpen}
                onClose={()=>setIsDeleteAttributeConfirmOpen(false)}
                onConfirm={invokeVehicleAttributeDelete}
                title={`Delete Attribute: ${vehicleDetails.model} and Year: ${vehicleDetails.year}`}
                text="Are you sure you want to delete this Model?"
            />
        </>
    )
}
export default CFAdminVehicleConfigDetails;